import TagIcon from "@uui/Tag01";
import { useParams } from "react-router";

import HeaderButton from "@app/analytics/components/reports/HeaderButton";
import ManageTagsPopover from "@app/analytics/components/TagPopover/ManageTagsPopover";
import useSessionMetadata from "@app/analytics/MeetingReport/hooks/useSessionMetadata";
import useSessionTags from "@app/common/hooks/tags/useSessionTags";
import useTags from "@app/common/hooks/tags/useTags";
import { toast } from "@app/common/hooks/useToasts";
import type { Tag } from "@app/common/types";

const MeetingReportTags = ({ disabled }: { disabled: boolean }) => {
  const { sessionId } = useParams();
  const { tags: allUserTags } = useTags();
  const {
    data: { tags: sessionTags, isRecurringMeeting },
  } = useSessionMetadata();

  const { updateSessionTags } = useSessionTags({
    sessionId: sessionId!,
    sessionTags,
    context: "sessionInfo",
  });

  const handleSave = (updatedTags: Tag[], applyToSeries?: boolean) => {
    updateSessionTags.mutate(
      { updatedTags, applyToSeries },
      {
        onError: () =>
          toast.error(
            "Oops! Something went wrong and one or more of your tags could not be saved."
          ),
      }
    );
  };

  return (
    <ManageTagsPopover
      allTags={allUserTags}
      appliedTags={sessionTags}
      canApplyToSeries={isRecurringMeeting}
      onSave={handleSave}
      renderControl={({ onClick }) => (
        <HeaderButton
          className="meeting-report__header__tags"
          startIcon={<TagIcon />}
          onClick={onClick}
          disabled={disabled}
        >
          Tags ({sessionTags.length})
        </HeaderButton>
      )}
    />
  );
};

export default MeetingReportTags;
